import React, { useState, useContext, useEffect} from 'react'

//router
import { Link, useLocation } from 'react-router-dom'

//react-bootstrap
import { Accordion, useAccordionButton, AccordionContext, Nav,Tooltip,OverlayTrigger} from 'react-bootstrap'
import { useProjectName } from '../../../../Context/ProjectNameContext';
import { useTranslation } from 'react-i18next';

function CustomToggle({ children, eventKey, onClick }) {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey, (active) => onClick({ state: !active, eventKey: eventKey }));
    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <Link to="#" aria-expanded={isCurrentEventKey ? 'true' : 'false'} className="nav-link" role="button" onClick={(e) => {
            decoratedOnClick(isCurrentEventKey)
        }}>
            {children}
        </Link>
    );
}

const VerticalNav = React.memo(() => {
    
    const [activeMenu, setActiveMenu] = useState(false)
    const [active, setActive]= useState('')
    let location = useLocation();

    const projectName = useProjectName();
    const { t, i18n } = useTranslation();

    // Function to close sidebar on mobile
    const closeSidebarOnMobile = () => {
        // Check if screen is mobile size
        if (window.innerWidth < 992) { // Bootstrap's lg breakpoint
            const aside = document.getElementsByTagName("ASIDE")[0];
            if (aside && !aside.classList.contains("sidebar-mini")) {
                aside.classList.add("sidebar-mini");
            }
        }
    };

        // Handle click outside to close sidebar on mobile
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Only run on mobile screens
            if (window.innerWidth < 992) {
                const aside = document.getElementsByTagName("ASIDE")[0];
                
                // Check if sidebar is open (doesn't have sidebar-mini class)
                if (aside && !aside.classList.contains("sidebar-mini")) {
                    // Check if click is outside the sidebar
                    if (aside && !aside.contains(event.target)) {
                        // Also check if click is not on the hamburger menu button
                        const hamburgerButton = document.querySelector('.sidebar-toggle');
                        if (!hamburgerButton || !hamburgerButton.contains(event.target)) {
                            aside.classList.add("sidebar-mini");
                        }
                    }
                }
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);

    return (
        <React.Fragment>
            <Accordion as="ul" className="navbar-nav iq-main-menu " id="sidebar-menu"
             style={{
    paddingBottom: "20px",
    marginBottom: window.innerWidth < 768 ? "130px" : "0px",
  }}>
{/* //    style={{paddingBottom:"20px", marginBottom:"130px"}} > */}
                <li className="nav-item static-item">
                    <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                        <span className="default-icon" style={{ margin:"auto"}}>
                        <img src="/social.png" alt="logo" style={{height: "50px", marginTop:"30px" }} />
                        </span>
                        <span className="mini-icon" data-bs-toggle="tooltip" title="Social" data-bs-placement="right">
                        <img src="/social.png" alt="logo" style={{ height: "40px", marginTop:"30px" }} />
                        </span>
                    </Link>
                </li>
                <li  className={`${location.pathname === '/hero-qr' ? 'active' : ''} nav-item `}>
                    <Link className={`${location.pathname === '/hero-qr' ? 'active' : ''} nav-link `} aria-current="page" to="/hero-qr" onClick={closeSidebarOnMobile}>
                        <OverlayTrigger placement="right" overlay={<Tooltip>{t("qr_hero")}</Tooltip>}>
                            <img src='/qrhero.jpg' style={{ height: "25px", width:"25px" }} />
                        </OverlayTrigger>
                        <span className="item-name" style={{fontWeight:"bold"}}>{t("qr_hero")}</span>
                    </Link>
                </li>
                <li  className={`${location.pathname === '/request-qrc' ? 'active' : ''} nav-item `}>
                    <Link className={`${location.pathname === '/request-qrc' ? 'active' : ''} nav-link `} aria-current="page" to="/request-qrc" onClick={closeSidebarOnMobile}>
                        <OverlayTrigger placement="right" overlay={<Tooltip>{t("platinum_qrc")}</Tooltip>}>
                          <img src='/exclusive.png' style={{ height: "25px", width:"25px" }} />
                        </OverlayTrigger>
                        <span className="item-name" style={{fontWeight:"bold"}}>{t("platinum_qrc")}</span>
                    </Link>
                </li>
                <li  className={`${location.pathname === '/critical' ? 'active' : ''} nav-item `}>
                    <Link className={`${location.pathname === '/critical' ? 'active' : ''} nav-link `} aria-current="page" to="/critical" onClick={closeSidebarOnMobile}>
                        <OverlayTrigger placement="right" overlay={<Tooltip>{t('critical_d')}</Tooltip>}>
                            <img src='/criticald.jpg' style={{ height: "25px", width:"25px" }} />
                        </OverlayTrigger>
                        <span className="item-name" style={{fontWeight:"bold"}}>{t('critical_d')}</span>
                    </Link>
                </li>
                <li  className={`${location.pathname === '/extra-pages/pages-comingsoon' ? 'active' : ''} nav-item `}>
                    <Link className={`${location.pathname === '/device-list' ? 'active' : ''} nav-link `} aria-current="page" to="/device-list" onClick={closeSidebarOnMobile}>
                        <OverlayTrigger placement="right" overlay={<Tooltip>{t('lost_and_found')}</Tooltip>}>
                            <img src='/tracked.png' style={{ height: "25px", width:"25px" }} />
                        </OverlayTrigger>
                        <span className="item-name" style={{fontWeight:"bold"}}>{t('lost_and_found')}</span>
                    </Link>
                </li>
                <Accordion.Item as="li" eventKey="store-menu" bsPrefix="nav-item">
                    <CustomToggle eventKey="store-menu" active={activeMenu === 'store-menu' ? true : false} onClick={(activeKey) => setActiveMenu(activeKey)}>
                        <OverlayTrigger placement="right" overlay={<Tooltip>{t('store')}</Tooltip>}>  
                            <img src='/store.png' style={{ height: "25px", width:"25px" }} />
                        </OverlayTrigger>
                        <span className="item-name" style={{fontWeight:"bold"}}>{t('store')}</span>
                        <i className="right-icon material-symbols-outlined">chevron_right</i>
                    </CustomToggle>
                    <Accordion.Collapse eventKey="store-menu">
                        <ul className="sub-nav">
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/store-item' ? 'active' : ''} nav-link`} to="/store-item" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg className="icon-10" xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g></g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t("dirido_products")}</Tooltip>}>  
                                        <img src='/diridoproduct.png' style={{ height: "25px", width:"25px" }} />
                                    </OverlayTrigger>
                                    <span className="item-name">{t("dirido_products")}</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/store-checkout' ? 'active' : ''} nav-link`} to="/store-checkout" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg className="icon-10" xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g></g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('checkout')}</Tooltip>}>  
                                        <img src='/checkout.png' style={{ height: "25px", width:"25px" }} />
                                    </OverlayTrigger>
                                    <span className="item-name">{t('checkout')}</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/store-orders' ? 'active' : ''} nav-link`} to="/store-orders" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg className="icon-10" xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g></g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t("my_orders")}</Tooltip>}>  
                                        <img src='/myorder.jpg' style={{ height: "25px", width:"25px" }} />
                                    </OverlayTrigger>
                                    <span className="item-name">{t("my_orders")}</span>
                                </Link>
                            </Nav.Item>
                        </ul>
                    </Accordion.Collapse>
                </Accordion.Item>
                <Accordion.Item as="li" eventKey="profile-menu" bsPrefix={`nav-item  `} onClick={() => setActive('profile')} >
                    <CustomToggle eventKey="profile-menu" onClick={(activeKey) =>  setActiveMenu(activeKey) }>
                        <OverlayTrigger placement="right" overlay={<Tooltip>{t('deals')}</Tooltip>}>
                            <img src='/deals.jpg' style={{ height: "25px", width:"25px" }} />
                        </OverlayTrigger>
                        <span className="item-name" style={{fontWeight:"bold"}}>{t('deals')}</span>
                        <i className="right-icon material-symbols-outlined">chevron_right</i>
                    </CustomToggle>
                    <Accordion.Collapse eventKey="profile-menu" >
                        <ul className="sub-nav">
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/deals' ? 'active' : ''} nav-link`} to="/deals" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('deals')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> D </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('deals')} </span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/jobs' ? 'active' : ''} nav-link`} to="/jobs" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('jobs')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> J </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('jobs')} </span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/entertainment' ? 'active' : ''} nav-link`} to="/entertainment" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('entertainment')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> E </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('entertainment')} </span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/housing' ? 'active' : ''} nav-link`} to="/housing" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('housing')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> H </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('housing')} </span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/forsale' ? 'active' : ''} nav-link`} to="/forsale" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('for_sale')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> F </i>
                                    </OverlayTrigger>
                                    <span className="item-name">{t('for_sale')} </span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/travel' ? 'active' : ''} nav-link`} to="/travel" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('travel')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> T </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('travel')} </span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/meet' ? 'active' : ''} nav-link`} to="/meet" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('meet')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> M </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('meet')} </span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/services' ? 'active' : ''} nav-link`} to="/services" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('services')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> S </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('services')} </span>
                                </Link>
                            </Nav.Item>
                        </ul>
                    </Accordion.Collapse>
                </Accordion.Item>
                <Accordion.Item as="li" eventKey="friends-menu" bsPrefix="nav-item">
                    <CustomToggle eventKey="friends-menu" onClick={(activeKey) => setActiveMenu(activeKey)}>
                        <OverlayTrigger placement="right" overlay={<Tooltip>{t('my_activities')}</Tooltip>}>  
                        <i className="icon material-symbols-outlined">
                            people
                        </i>
                        </OverlayTrigger>
                        <span className="item-name" style={{fontWeight:"bold"}}>{t('my_activities')}</span>
                        <i className="right-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                            </svg>
                        </i>
                    </CustomToggle>
                    <Accordion.Collapse eventKey="friends-menu" >
                        <ul className="sub-nav">
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/allpost' ? 'active' : ''} nav-link`} to="allpost" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('allPost')}</Tooltip>}>  
                                      <i className="sidenav-mini-icon"> A </i>
                                    </OverlayTrigger>
                                    <span className="item-name">{t('allPost')}</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/mypost' ? 'active' : ''} nav-link`} to="mypost" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('my_posts')}</Tooltip>}>  
                                      <i className="sidenav-mini-icon"> P </i>
                                    </OverlayTrigger>
                                    <span className="item-name">{t('my_posts')}</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/connections' ? 'active' : ''} nav-link`} to="/connections" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('my_connections')}</Tooltip>}>  
                                        <i className="sidenav-mini-icon"> FP </i>
                                    </OverlayTrigger>
                                    <span className="item-name">{t('my_connections')}</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/groups' ? 'active' : ''} nav-link`} to="/groups" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('groups')}</Tooltip>}>  
                                        <i className="sidenav-mini-icon"> FR </i>
                                    </OverlayTrigger>
                                    <span className="item-name">{t('groups')}</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none" }}>
                                <Link className={`${location.pathname === '/events' ? 'active' : ''} nav-link`} to="/events" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('events')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> E </i>
                                    </OverlayTrigger>
                                    <span className="item-name"> {t('events')}</span>
                                </Link>
                            </Nav.Item>
                            <Nav.Item as="li" style={{ listStyle: "none"}}>
                                <Link className={`${location.pathname === '/saved' ? 'active' : ''} nav-link`} to="/saved" onClick={closeSidebarOnMobile}>
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                            <g>
                                                <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                            </g>
                                        </svg>
                                    </i>
                                    <OverlayTrigger placement="right" overlay={<Tooltip>{t('saved_other_posts')}</Tooltip>}>
                                     <i className="sidenav-mini-icon"> S </i>
                                    </OverlayTrigger>
                                    <span className="item-name">{t('saved_other_posts')}</span>
                                </Link>
                            </Nav.Item>
                        </ul>
                    </Accordion.Collapse>
                </Accordion.Item>
            </Accordion>
        </React.Fragment>
    )
})

export default VerticalNav